import { useAmp } from "next/amp"
import classnames from "classnames"
import styled from "styled-components"

const IMAGES_CLASS = "rich-images"
const IMAGES_ITEM_CLASS = "rich-images-item"

type TBlockBorderUnion = "shadow" | "none"
type TBlockRadiusUnion = "radius" | "none"

interface SliderProps {
  images: { src: string; alt: string }[]
  align: "left" | "right"
  blockBorder: TBlockBorderUnion
  blockRadius: TBlockRadiusUnion
}

export function Images(props: SliderProps) {
  const { images, align, blockBorder, blockRadius } = props
  const isAmp = useAmp()

  return (
    <Root
      className={classnames(IMAGES_CLASS, "flex", {
        "justify-start": align === "left",
        "justify-end": align === "right",
      })}
      blockBorder={blockBorder}
      blockRadius={blockRadius}
    >
      {images.map((img, index) => (
        <div className={IMAGES_ITEM_CLASS} key={index}>
          {isAmp ? (
            <amp-img src={img.src} width="1" height="1" layout="responsive" />
          ) : (
            <img src={img.src} alt={img.alt} />
          )}
        </div>
      ))}
    </Root>
  )
}

const Root = styled.div<{
  blockBorder: TBlockBorderUnion
  blockRadius: TBlockRadiusUnion
}>`
  & .${IMAGES_ITEM_CLASS} img {
    box-shadow: ${(props) =>
      props.blockBorder === "shadow"
        ? "0 11.083744049072266px 22.16748809814453px 0 #00000029"
        : false};
    border-radius: ${(props) =>
      props.blockRadius === "radius" ? "14px" : false};
  }
`
